export const ASSETS = {
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_9b29f9f5-cac9-4845-89b2-a83207065679/artifacts/yb9ewamq_Essay%20AC%20logo.png",
  before:
    "https://customer-assets-lqy194kg.emergentagent.net/job_9b29f9f5-cac9-4845-89b2-a83207065679/artifacts/bq5cepmd_IMAGE%202026-07-28%2010%3A06%3A55.jpg",
  after:
    "https://customer-assets-lqy194kg.emergentagent.net/job_9b29f9f5-cac9-4845-89b2-a83207065679/artifacts/7wzignvm_IMAGE%202026-07-28%2010%3A07%3A22.jpg",
};

export const LINKS = {
  enrol: "https://rzp.io/rzp/EssayAdvantageClub",
  handbook: "https://rzp.io/rzp/dQaQPSh",
  x: "https://x.com/ArpitaSharmaaa",
  instagram: "https://www.instagram.com/upsc_with_arpita/?hl=en",
  telegram: "https://telegram.me/ArpitaSharma",
  email: "mailto:upscwithease@gmail.com",
  emailPlain: "upscwithease@gmail.com",
};

export const LAUNCH_DATE = "2026-08-04T00:00:00+05:30";

export const FEATURES = [
  {
    icon: "Video",
    title: "10 Recorded Classes",
    desc: "Watch anytime, rewind anything. Core concepts broken down into bingeable lessons you actually finish.",
    span: "md:col-span-7",
    tone: "light",
  },
  {
    icon: "Radio",
    title: "6 LIVE Classes",
    desc: "Real-time, camera-on sessions with Arpita. Ask doubts, get answered on the spot.",
    span: "md:col-span-5",
    tone: "dark",
  },
  {
    icon: "ClipboardCheck",
    title: "Weekly Report Cards",
    desc: "A performance-based scorecard every single week. See exactly where you stand and what to fix next.",
    span: "md:col-span-5",
    tone: "green",
  },
  {
    icon: "NotebookPen",
    title: "Assignment Handbooks",
    desc: "Structured writing prompts + model frameworks so you never stare at a blank page again.",
    span: "md:col-span-7",
    tone: "light",
  },
  {
    icon: "BookOpen",
    title: "Modules & Class Notes",
    desc: "Every session comes with crisp, shareable notes — your ready-to-revise essay bible.",
    span: "md:col-span-7",
    tone: "light",
  },
  {
    icon: "PlayCircle",
    title: "LIVE Session Recordings",
    desc: "Missed a live class? Never a problem. Every LIVE session is recorded and shared with you.",
    span: "md:col-span-5",
    tone: "light",
  },
];

export const WEEKS = [
  {
    week: "Week 1",
    dates: "4 Aug (Tue) – 8 Aug (Sat)",
    days: "Day 1–5",
    theme: "Foundations of Great Essays",
    off: false,
  },
  {
    week: "Week 2",
    dates: "10 Aug (Mon) – 15 Aug (Sat)",
    days: "Day 6–11",
    theme: "Building Powerful Arguments",
    off: false,
  },
  {
    week: "Sunday",
    dates: "16 Aug",
    days: "—",
    theme: "OFF • Reflection & Revision",
    off: true,
  },
  {
    week: "Week 3",
    dates: "17 Aug (Mon) – 22 Aug (Sat)",
    days: "Day 12–17",
    theme: "Philosophy, Ethics & Multi-Dimensional Thinking",
    off: false,
  },
  {
    week: "Sunday",
    dates: "23 Aug",
    days: "—",
    theme: "OFF • Reflection & Revision",
    off: true,
  },
  {
    week: "Week 4",
    dates: "24 Aug (Mon) – 29 Aug (Sat)",
    days: "Day 18–23",
    theme: "Storytelling, Examples & Essay Structure",
    off: false,
  },
  {
    week: "Sunday",
    dates: "30 Aug",
    days: "—",
    theme: "OFF • Reflection & Revision",
    off: true,
  },
  {
    week: "Week 5",
    dates: "31 Aug (Mon) – 5 Sept (Sat)",
    days: "Day 24–29",
    theme: "Speed, Refinement & UPSC-Level Practice",
    off: false,
  },
  {
    week: "Finale",
    dates: "7 Sept (Mon)",
    days: "Day 30",
    theme: "Grand Essay Challenge & Graduation",
    off: false,
    finale: true,
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "You write. She evaluates. Personally.",
    body: "No auto-generated feedback. No bots. Arpita sits with your copy, pen in hand, and shows you exactly why a line scored 0.5 — and how it becomes an 8.",
  },
  {
    n: "02",
    title: "Comparison is the fastest teacher.",
    body: "Every week you see your own before-and-after. When you watch a 0.5 answer transform into an 8, the lesson sticks forever.",
  },
  {
    n: "03",
    title: "Structure beats talent.",
    body: "Great essays aren't magic — they're a repeatable system. In 30 days you internalise the frameworks toppers use under exam pressure.",
  },
  {
    n: "04",
    title: "Consistency, gamified.",
    body: "Daily sessions, weekly report cards, Sundays to breathe. A rhythm designed so you actually finish — not burn out on Day 4.",
  },
];

export const PRICE_COMPARISON = [
  { label: "Famous Coaching A", price: "₹12,000" },
  { label: "Famous Coaching B", price: "₹11,000" },
  { label: "Famous Coaching C", price: "₹5,000" },
];
